'use client';
import { useIsoLayoutEffect } from '@base-ui/utils/useIsoLayoutEffect';
import { useDisposable } from '@mui/x-internals/useDisposable';
import { useAdapter } from '@mui/x-scheduler-internals/use-adapter';
import { EventTimelinePremiumStore } from './EventTimelinePremiumStore';
import type { EventTimelinePremiumStoreParameters } from './EventTimelinePremiumStore.types';

export function useEventTimelinePremium<TEvent extends object, TResource extends object>(
  parameters: EventTimelinePremiumStoreParameters<TEvent, TResource>,
): EventTimelinePremiumStore<TEvent, TResource> {
  const adapter = useAdapter();
  const store = useDisposable(() => new EventTimelinePremiumStore(parameters, adapter));

  useIsoLayoutEffect(
    () => store.updateStateFromParameters(parameters, adapter),
    [store, adapter, parameters],
  );

  return store;
}
